export default {
  noData: 'Нет данных',
  nothingFound: 'Ничего не найдено',
};
